import { OrganizationProvider } from "./provider";

export interface IPractice
{
    name: string;
    ein: string;
    facilities: OrganizationProvider[];
    aliases: string[];
}

export class Practice implements IPractice
{
    constructor
    (
        public name: string,
        public ein: string,
        public facilities: OrganizationProvider[] = [],
        public aliases: string[] = []
    )
    {
    }
}